import { post } from '@/utils/request';

export interface MessageForm {
  /** 姓名 */
  userName: string;
  /** 单位名称 */
  companyName: string;
  /** 联系方式 */
  contactInfo: string;
  /** 关注产品 */
  productType: string;
  /** 咨询类型 */
  messageType: string;
  /** 留言内容（最多500字） */
  messageContent: string;
}

export function submitMessage(data: MessageForm) {
  return post<{ code: number; msg: string }>('/system/message/submit', data);
}
